import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private subject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public loader = this.subject.asObservable();

  constructor() { }

  showLoader(){
    this.subject.next(true);
  }

  hideLoader(){
    this.subject.next(false);
  }
}
